export const divisionColors = {
  raspberry: '#e85192',
  grassGreen: '#4caf50',
  purple: '#a56eff',
  orange: '#ffa04c',
  lightYellow: '#eeec49',
  azure: '#39d2b4',
  blue: '#28c0e1',
  deepRed: '#b71c1c',
  forestGreen: '#1b5e20',
  violet: '#7c4dff',
  goldenRod: '#daa520',
  skyBlue: '#00b0ff',
  coral: '#ff6f61',
  lime: '#aeea00',
  darkCyan: '#006064',
};

// Same legend with translucent colors, as used behind the ColorLegend blocks
export function fadeColorLegend(colorLegend) {
  return Object.fromEntries(
    Object.entries(colorLegend).map(([division, item]) => [
      division,
      { ...item, color: item.color + '50' },
    ]),
  );
}

export function buildColorLegend(divisions) {
  const colorValues = Object.values(divisionColors);
  const legend = {};
  divisions.forEach((division, i) => {
    legend[division] = { color: colorValues[i] };
  });
  return legend;
}
